<template>
  <div class="absolute z-20 w-full max-w-sm left-4 bottom-4" :class="selectedPin?.file_id[0] ? 'h-[480px]' : 'h-80'">
    <div class="bg-base-100 overflow-auto h-full w-full rounded-2xl">
      <MediaView v-if="selectedPin?.file_id[0]" :fileId="selectedPin.file_id[0]"
        class="w-64 h-40 object-cover bg-gray-500/25 mx-auto" :width="240" :height="160" />
      <div class="pt-1 pb-4 px-4 flex flex-col h-80 w-full justify-between">
        <div class="relative text-center w-full">
          <h1 class="text-accent text-xl truncate pr-8">
            {{ selectedPin?.title }}
          </h1>
          <button class="absolute right-0 top-0 btn btn-sm btn-ghost btn-square text-accent" @click="$emit('close')">
            <XMarkIcon class="w-6 h-6" />
          </button>
        </div>
        <p>
          {{ selectedPin?.description }}
        </p>
        <div class="flex items-center w-full mt-auto">
          <button class="btn btn-primary flex-1 text-accent" @click="$emit('see-more')">
            {{ $t('seeMore') }}
          </button>
          <LikeButton v-if="!selectedPin?._id.startsWith('organization')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePinsStore } from '@/stores/pins'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { storeToRefs } from 'pinia'

import LikeButton from '@/components/LikeButton.vue'
import MediaView from '@/components/MediaView.vue'

const pinsStore = usePinsStore()
const { selectedPin } = storeToRefs(pinsStore)

defineEmits<{
  (e: 'close'): void
  (e: 'see-more'): void
}>()
</script>
